export const environment = {
  version: '1.146.0',
  production: false,
  API_URL: 'https://dev-orderadmin-service.jamatu.com/api/v1',
  BASE_API_URL: 'https://dev-orderadmin-service.jamatu.com',
  i18nBaseUrl: 'https://dev-orderadmin-service.jamatu.com/api/i18n',
  ORDER_ADMIN_URL: 'https://dev-orderadmin.jamatu.com/',
  ADS_MANAGER_URL: 'https://dev-adsmanager.jamatu.com/',
  AUTH0_DOMAIN: 'dev-mexdubsh7cvlq1b8.us.auth0.com',
  AUTH0_AUDIENCE: 'https://dev-orderadmin-api.jamatu.com/',
  AUTH0_CLIENTID: 'dc8JNeHFcZOCX2Yh8AIcwHkPwAqLtj52',
  AUTH0_PRE_PATH: 'dev-',
};
